import * as yup from 'yup';
import { memoize } from 'lodash';

import TranslationHelper from '../../../helpers/TranslationHelper';
import {
    DEFAULT_STRING_MAX_LENGTH,
    FIELD_REQUIRED,
    NAME_STRING_MAX_LENGTH,
    VALUE_TOO_LONG,
} from '../../../constants/yup';

export const ticketSchema = memoize(() =>
    yup.object().shape({
        name: yup
            .string()
            .trim()
            .required(TranslationHelper.translate(FIELD_REQUIRED))
            .max(
                NAME_STRING_MAX_LENGTH,
                TranslationHelper.translate(VALUE_TOO_LONG)
            ),
        status: yup
            .string()
            .trim()
            .required(TranslationHelper.translate(FIELD_REQUIRED)),
        description: yup
            .string()
            .max(
                DEFAULT_STRING_MAX_LENGTH,
                TranslationHelper.translate(VALUE_TOO_LONG)
            ),
        notice: yup
            .string()
            .max(
                DEFAULT_STRING_MAX_LENGTH,
                TranslationHelper.translate(VALUE_TOO_LONG)
            ),
    })
);
